import React from 'react';
import Carousel from '../Shared/components/Carousel';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import CarouselWithClickableCardsSlide from './shared/slide';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CarouselWithClickableCardsComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CarouselWithClickableCardsComponent" />;
  }
  const { fields, params, i18n } = props;
  /**
   * We want to remove the padding-bottom for the carousel navigation in this case
   * Otherwise there will be extra space in case of less than 4 items
   */
  return (
    <div
      className={clsx(
        'main-carousel__wrapper',
        fields?.items?.length <= 5 && 'remove-padding',
        'add-margins',
        props.params.Styles
      )}
    >
      <Carousel fields={fields} params={params} lang={i18n.language} arrow="white">
        {fields?.items?.map((card, index) => (
          <SwiperSlide key={index}>
            <CarouselWithClickableCardsSlide data={card} index={index} />
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
};

export default withTranslation()(CarouselWithClickableCardsComponent);
